"use client";

import { formatDistanceToNow } from "date-fns";
import { RelativeTime } from "modules/common/components/ui/RelativeTime";
import { useHydrated } from "modules/common/hooks/useHydrated";

export const FormattedDate = ({ date }: { date: Date | string }) => {
  // The tooltip is an attribute, so it can't rely on the
  // suppressHydrationWarning inside RelativeTime — fill it after mount.
  const hydrated = useHydrated();

  return (
    <div
      className={"tooltip justify-center md:flex"}
      data-tip={
        hydrated
          ? `First added ${formatDistanceToNow(new Date(date), {
              addSuffix: true,
            })}`
          : undefined
      }
    >
      <RelativeTime date={date} className="text-base-content text-sm" />
    </div>
  );
};
